import { RegisterAssignment } from "../models/RegisterAssignment";

export interface ProjectGroup {
  projectName: string;
  registers: RegisterGroup[];
}

export interface RegisterGroup {
  registerId: string;
  registerTitle: string;
  assignments: RegisterAssignment[];
}

export function groupAssignmentsByProject(assignments: RegisterAssignment[]): ProjectGroup[] {
  const projectMap: Record<string, ProjectGroup> = {};

  for (const a of assignments) {
    const projectId = a.permitRegister.project?.id ?? "unknown";
    const projectName = a.permitRegister.project?.name ?? "Unknown Project";

    if (!projectMap[projectId]) {
      projectMap[projectId] = { projectName, registers: [] };
    }

    const project = projectMap[projectId];
    let register = project.registers.find((r) => r.registerId === a.permitRegister.id);

    if (!register) {
      register = { registerId: a.permitRegister.id, registerTitle: a.permitRegister.title, assignments: [] };
      project.registers.push(register);
    }

    register.assignments.push(a);
  }

  return Object.values(projectMap);
}
